export function resetPaymentsState() {
  return {
    type: 'RESET_PAYMENTS_STATE',
  }
}

/**
 *
 * TODO: PAT-1574 Remove this when "Stripe" is removed
 *
 * @deprecated
 */
export function getPolicies() {
  return {
    type: 'GET_POLICIES',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getPolicies',
            mock: false
          },
        },
        commit: {
          type: 'GET_POLICIES_COMMIT',
        },
        rollback: {
          type: 'GET_POLICIES_ROLLBACK',
        }
      },
    },
  }
}

/**
 *
 * TODO: PAT-1574 Remove since it's deprecated
 *
 * @deprecated
 */
export function getPaymentPolicies() {
  return {
    type: 'GET_PAYMENT_POLICIES',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getPoliciesDetailsKioskSettings',
            mock: false,
          },
        },
        commit: {
          type: `GET_PAYMENT_POLICIES_COMMIT`,
        },
        rollback: {
          type: 'GET_PAYMENT_POLICIES_ROLLBACK',
        }
      },
    },
  }
}

export function setSelectedPaymentPolicies(selectedPaymentPolicies) {
  return {
    type: 'SET_SELECTED_PAYMENT_POLICIES',
    payload: { selectedPaymentPolicies }
  }
}

export function getPaymentOptions() {
  return {
    type: 'GET_PAYMENT_OPTIONS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/payments/getPaymentOptions',
            mock: false
          },
        },
        commit: {
          type: 'GET_PAYMENT_OPTIONS_COMMIT',
        },
        rollback: {
          type: 'GET_PAYMENT_OPTIONS_ROLLBACK',
        }
      },
    },
  }
}

export function sendETransferEmail(data) {
  return {
    type: 'SEND_E_TRANSFER_EMAIL',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            base: '/payments/sendEmail',
            mock: false
          },
        },
        commit: {
          type: 'SEND_E_TRANSFER_EMAIL_COMMIT',
        },
        rollback: {
          type: 'SEND_E_TRANSFER_EMAIL_ROLLBACK',
        }
      },
    },
  }
}

export function submitEPayPaymentInformation(data) {
  return {
    type: 'SUBMIT_E_PAY_PAYMENT_INFORMATION',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            base: '/payments/ePayPaymentInformation',
          },
        },
        commit: {
          type: 'SUBMIT_E_PAY_PAYMENT_INFORMATION_COMMIT',
        },
        rollback: {
          type: 'SUBMIT_E_PAY_PAYMENT_INFORMATION_ROLLBACK',
        }
      },
    },
  }
}

export function processEPayPayment(data) {
  return {
    type: 'PROCESS_E_PAY_PAYMENT',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            base: '/payments/processEPayPayment',
          },
        },
        commit: {
          type: 'PROCESS_E_PAY_PAYMENT_COMMIT',
        },
        rollback: {
          type: 'PROCESS_E_PAY_PAYMENT_ROLLBACK',
        }
      },
    },
  }
}

/**
 *
 * TODO: PAT-1574 Remove Stripe code
 *
 * @deprecated
 */
export function makePayment(data) {
  return {
    type: 'MAKE_PAYMENT',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            base: '/payments/payment',
            mock: false
          },
        },
        commit: {
          type: 'MAKE_PAYMENT_COMMIT',
        },
        rollback: {
          type: 'MAKE_PAYMENT_ROLLBACK',
        }
      },
    },
  }
}
